/*
 * @Description: mark
 * @Author: wangwangwang
 * @Date: 2020-07-23 15:01:32
 * @LastEditors: hexy
 * @LastEditTime: 2024-03-19 16:38:59
 */

/**
 * @Description: 参数
 * @Param:
 * @Author: wangwangwang
 */
import Cookies from "js-cookie";
export default {
  Constant: {
    hanldeMenu: [
      {
        name: "抄送",
        id: "1",
      },
      {
        name: "退回",
        id: "2",
      },
      {
        name: "交办",
        id: "3",
      },
      {
        name: "协审",
        id: "4",
      },
      {
        name: "加签",
        id: "5",
      },
      {
        name: "减签",
        id: "6",
      },
      {
        name: "导出数据",
        id: "7",
      },
    ],
  },
};
/**
 * @Description: 格式化Tree数据
 * @Param: {source, id, parentId, children, firstLayer}格式化的数据；id子ID；parentId父ID；children要生成的子对象名；firstLayer第一层父ID
 * @Author: wangwangwang
 */
export const formatTreeData = (source, id, parentId, children, firstLayer) => {
  const cloneData = JSON.parse(JSON.stringify(source));
  if (cloneData.length) {
    // return cloneData.filter(father => {
    //   const fathercopy = father
    //   const branchArr = cloneData.filter(child => father[id] === child[parentId])
    //   if (branchArr.length > 0) {
    //     fathercopy[children] = branchArr
    //   }
    //   return father[parentId] === firstLayer
    // })
    let data = [];
    for (let father = 0; father < cloneData.length; father++) {
      const fathercopy = cloneData[father];
      let branchArr = [];
      for (let child = 0; child < cloneData.length; child++) {
        const childData = cloneData[child];
        if (fathercopy[id] === childData[parentId]) {
          branchArr.push(cloneData[child]);
        }
      }
      if (branchArr.length > 0) {
        fathercopy[children] = branchArr;
      }
      if (fathercopy[parentId] === firstLayer) {
        data.push(cloneData[father]);
      }
    }
    return data;
  }
  return [];
};

const joinLabel = (obj, keys) => {
  let str = "";
  for (let i = 0, len = keys.length; i < len; i++) {
    str += obj[keys[i]];
  }
  return str;
};

export const formatTreeDataByKeys = (source, id, parentId, keys, children, firstLayer) => {
  const cloneData = JSON.parse(JSON.stringify(source));
  if (cloneData.length) {
    return cloneData.filter(father => {
      father.name = joinLabel(father, keys);
      const fathercopy = father;
      const branchArr = cloneData.filter(child => father[id] === child[parentId]);
      if (branchArr.length > 0) {
        fathercopy[children] = branchArr;
      }
      return father[parentId] === firstLayer;
    });
  }
  return [];
};

export const formatOrganization = (data, id) => {
  console.log(data);
  const copyData = JSON.parse(JSON.stringify(data));
  const newArry = [];
  const findOrganization = (findData, findId) => {
    for (let i = 0; i < findData.length; i += 1) {
      if (findData[i].id === findId) {
        newArry.unshift(findData[i]);
        if (findData[i].parentId !== "parent_id") {
          findOrganization(findData, findData[i].parentId);
        } else {
          return newArry;
        }
      }
    }
  };
  if (copyData.length) {
    find();
    findOrganization(copyData, id);
  }
  return newArry;
};

/**
 * @Description: 格式化table数据  数据存在没有id及pid关系时
 * @Param: {source, id, parentId, children, firstLayer}格式化的数据；id子ID；parentId父ID；children要生成的子对象名；firstLayer第一层父ID
 * @Author: wangwangwang
 */

export const transData = (a, idStr, pidStr, chindrenStr) => {
  const r = [];
  const hash = {};
  const id = idStr;
  const pid = pidStr;
  const children = chindrenStr;
  let i = 0;
  let j = 0;
  const len = a.length;
  for (; i < len; i += 1) {
    hash[a[i][id]] = a[i];
  }
  for (; j < len; j += 1) {
    const aVal = a[j];
    const hashVP = hash[aVal[pid]];
    if (hashVP) {
      !hashVP[children] && (hashVP[children] = []);
      hashVP[children].push(aVal);
    } else {
      r.push(aVal);
    }
  }
  return r;
};

// 两个数组对象是否包含相同项
export function compareArrays(arr1, arr2, key) {
  const shortArr = arr1.length < arr2.length ? arr1 : arr2;
  const longArr = arr1.length < arr2.length ? arr2 : arr1;
  return shortArr.find(item1 => longArr.find(item2 => item1[key] === item2[key])) !== undefined;
}

/**
 * @Description: 格式化table数据  数据存在没有id及pid关系时
 * @Param: {source, id, parentId, children, firstLayer}格式化的数据；id子ID；parentId父ID；children要生成的子对象名；firstLayer第一层父ID
 * @Author: wangwangwang
 */

export const transDataByKey = (a, idStr, pidStr, keys, chindrenStr) => {
  const r = [];
  const hash = {};
  const id = idStr;
  const pid = pidStr;
  const children = chindrenStr;
  let i = 0;
  let j = 0;
  const len = a.length;
  for (; i < len; i += 1) {
    hash[a[i][id]] = a[i];
  }
  for (; j < len; j += 1) {
    const aVal = a[j];
    const hashVP = hash[aVal[pid]];
    aVal.name = joinLabel(aVal, keys);
    /*  console.log(123, keys, aVal.name) */
    if (hashVP) {
      !hashVP[children] && (hashVP[children] = []);
      hashVP[children].push(aVal);
    } else {
      r.push(aVal);
    }
  }
  return r;
};

/*去除完全重复的*/
export const arrRepeat = obj => {
  obj.forEach((item, index) => {
    let str = JSON.stringify(item);
    obj[index] = str;
  });
  var newArr = [...new Set(obj)];
  newArr.forEach((item, index) => {
    let json = JSON.parse(item);
    newArr[index] = json;
  });
  return newArr;
};
/*根据str去重*/
export const unique = (arr, str) => {
  // 根据唯一标识orderId来对数组进行过滤
  const res = new Map(); //定义常量 res,值为一个Map对象实例 //返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
  return arr.filter(arr => !res.has(arr[str]) && res.set(arr[str], 1));
};
/*设置获取流程节点ID*/
export const getNodeId = () => {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
};

export const _debounce = (fn, wait) => {
  const delay = wait || 200;
  var timer;
  return function () {
    const th = this;
    const args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      timer = null;
      fn.apply(th, args);
    }, delay);
  };
};

function getSubdomain() {
  try {
    let subdomain = "";
    const key = `mh_${Math.random()}`;
    const expiredDate = new Date(0);
    const { domain } = document;
    const domainList = domain.split(".");

    const reg = new RegExp(`(^|;)\\s*${key}=12345`);
    const ipAddressReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;

    // 若为 IP 地址、localhost，则直接返回
    if (ipAddressReg.test(domain) || domain === "localhost") {
      return domain;
    }

    const urlItems = [];
    urlItems.unshift(domainList.pop());

    while (domainList.length) {
      urlItems.unshift(domainList.pop());
      subdomain = urlItems.join(".");

      const cookie = `${key}=12345;domain=.${subdomain}`;
      document.cookie = cookie;

      if (reg.test(document.cookie)) {
        document.cookie = `${cookie};expires=${expiredDate}`;
        break;
      }
    }

    return "." + subdomain || "." + document.domain;
  } catch (e) {
    return "." + document.domain;
  }
}

//获取cookie、
export function getCookie(name) {
  const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  const arr = document.cookie.match(reg);
  console.log(arr);
  return arr ? arr[2] : null || null;
}
//设置cookie,增加到vue实例方便全局调用
export function setCookie(c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value) + (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
}

//设置cookie,domain增加到vue实例方便全局调用
export function setDomainCookie(name, value, expiredays) {
  var exdate = new Date();
  var domain = getSubdomain();
  console.log(domain);
  exdate.setDate(exdate.getDate() + expiredays);
  Cookies.set(name, value, {
    domain: domain,
    expires: exdate,
  });
}

//删除cookie
export function delCookie(name) {
  setCookie(name, "", -1);
}
//删除domain cookie
export function delDomainCookie(name) {
  var domain = getSubdomain();
  console.log(domain);
  Cookies.remove(name, {
    domain: domain,
  });
}

// 获取URL参数
export function GetQueryString() {
  let url = location.href; //获取url中"?"符后的字串
  let theRequest = new Object();
  if (url.indexOf("?") != -1) {
    let uri = url.split("?")[1],
      strs = uri.split("&");
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    }
  }
  return theRequest;
}

// const lineToHump = (name = '') => {
//   console.log(name)
//   let lowerCase = name.toLocaleLowerCase()
// 	return lowerCase.replace(/_(\w)/g, (all, letter) => {
// 		return letter.toUpperCase();
// 	})
// }
const getObjRow = (list, key) => {
  return list.filter(item => {
    return item[key] === 1;
  });
};

/**
 * 获取限制列表
 * @param {array}} list
 */
export function getLimitTreeFeilds(list) {
  let res = {};
  let idObj = getObjRow(list, "isId");
  if (idObj.length) {
    res.id = idObj[0].columnName;
  }
  idObj = getObjRow(list, "isPid");
  if (idObj.length) {
    res.pid = idObj[0].columnName;
  }
  idObj = getObjRow(list, "limitControl");
  if (idObj.length) {
    res.keyId = idObj[0].columnName;
  }
  res.keys = [];
  for (let i = 0, len = list.length; i < len; i++) {
    if (list[i].isVisible) {
      res.keys.push(list[i].columnName);
    }
  }
  return res;
}
function isNeedDecodeURI(str) {
  if (typeof str !== "string" || str === "") {
    return false; // 非字符串/空字符串无需解码
  }

  // 正则匹配：% 后跟两位十六进制数（URL编码的核心特征）
  // 匹配规则：%[0-9A-Fa-f]{2}
  const encodePattern = /%[0-9A-Fa-f]{2}/g;
  const encodeMatches = str.match(encodePattern);

  // 1. 无编码特征，直接返回不需要解码
  if (!encodeMatches || encodeMatches.length === 0) {
    return false;
  }

 // 2. 排除非编码的%（比如"50%" "100%"这类百分比）
 const percentPattern = /(\d+)%/g;
 let purePercentCount = 0;
 // 修复：循环中仅用exec计数，不再保留未使用的percentMatch变量
 while (percentPattern.exec(str) !== null) {
   purePercentCount++; // 统计纯百分比符号的数量
 }

  // 3. 编码特征数 > 纯百分比数，判定为需要解码
  return encodeMatches.length > purePercentCount;
}
 //判断是否需要decodeURI解码
export function safeDecodeURI(str) {
  if (isNeedDecodeURI(str)) {
    try {
      return decodeURI(str); // 安全解码
    } catch (e) {
      console.error("解码失败：", e);
      return str; // 解码出错返回原字符串
    }
  }
  return str; // 不需要解码直接返回
}

/*table累计求和 prop为字段名  data为列表数据  sumss为求和值*/
export function getSum(prop, data) {
  let sumss = 0;
  const values = data.map(item => Number(item[prop]));
  if (!values.every(value => isNaN(value))) {
    sumss = values.reduce((prev, curr) => {
      const value = Number(curr);
      if (!isNaN(value)) {
        return prev + curr;
      } else {
        return prev;
      }
    }, 0);
  } else {
    sumss = "";
  }
  return Number(sumss).toFixed(2);
}
export const LOGIN_TIP = "本平台为互联网非涉密平台，严禁处理、传输国家秘密、工作秘密。";
//华荥厂销售发票审批
export const UPLOAD_TIP = "严禁在本互联网非涉密平台处理、传输国家秘密，请确认扫描、传输的文件资料不涉及国家秘密、工作秘密。";
